
<span *ngIf="!message.notification_type" class="message__avatar">
    <img class="img-fluid img-thumbnail" src="../../../../../../assets/img/innporting-logo.svg" *ngIf="message.sender_id == 133600641">
    <!-- <img class="img-fluid img-thumbnail" src="{{this.globals.getEnvironment().baseApiUrl}}files/{{this.globals.enterpriseLogo}}" *ngIf="message.sender_id == this.globals.getChatUser().userChatId"> -->
    <i *ngIf="message.sender_id != 133600641 && message.sender_id != this.globals.getChatUser().userChatId" class="material-icons notranslate">account_circle</i>
</span>
<div (visibility)="visibility($event)" class="message__content" #element >
  <div *ngIf="!message.notification_type" class="message__sender_and_status">
    <!-- <p class="message__sender_name" *ngIf="message.sender_id == this.globals.getChatUser().userChatId">You</p> -->
    <p class="message__sender_name" *ngIf="message.sender_id != this.globals.getChatUser().userChatId">{{message.full_name}}</p>
  </div>
  <div class="message__text_and_date">
    <div class="message__text_wrap">
      <p [ngStyle]="{'text-align':message.notification_type ? 'center' : 'left' }"
      *ngIf="message.message && message.message !== CONSTANTS.ATTACHMENT.BODY " [class.m-notification_message]="message.notification_type == 2"
      [class.message__you]="message.sender_id == this.globals.getChatUser().userChatId" class="message__text">{{message.message}}</p>
      <div *ngIf="message.attachments && message.attachments.length" class="message__attachments_wtap"
      [class.attach__you]="message.sender_id == this.globals.getChatUser().userChatId">
        <img *ngFor="let attachment of message.attachments" (load)="loadImagesEvent($event)" alt="attachment" class="message_attachment"
        src="{{attachment.src}}">
        <a target="_blank" *ngFor="let attachment of message.attachments" href="{{attachment.src}}">
          <div class="attach">
            <span class="material-icons notranslate">
              file_download
            </span>
              <span>Download file</span>
          </div>
          </a>
      </div>
    </div>
    <div class="message__timestamp">
      <p class="message__status j-message__status font-weight-bold">{{message.status}}</p>
      <p>{{message.date_sent | date:'hh:mm'}}</p>
    </div>
  </div>
</div>

